import { Alert, Chip, Stack, Typography } from '@mui/material';
import { UserProfileContainer } from './common';
import { UserDetailsQuery } from '@/__generated__/graphql';
import { chipStyles } from '../styles';

type Props = {
  groups: UserDetailsQuery['userDetails']['userGroups'];
};
export const UserGroups = ({ groups }: Props) => {
  const List = () => {
    if (!groups) {
      return (
        <Alert severity="error" sx={{ mb: 2 }}>
          An error occurred while fetching groups
        </Alert>
      );
    }

    if (groups.length === 0) {
      return (
        <Alert severity="info" sx={{ mb: 2 }}>
          User is not part of any group
        </Alert>
      );
    }

    return (
      <Stack direction="row" flexWrap="wrap" gap="0.8rem">
        {groups.map((group) => (
          <Chip
            key={group?.name}
            label={group?.name}
            color="primary"
            sx={{
              ...chipStyles,
              width: 'fit-content',
              marginBottom: '0.8rem',
            }}
          />
        ))}
      </Stack>
    );
  };

  return (
    <UserProfileContainer
      style={{
        flexDirection: 'column',
      }}
    >
      <Typography fontSize={16} fontWeight={700} mb={1}>
        Part of groups
      </Typography>

      <List />
    </UserProfileContainer>
  );
};
